import { MonsterEntity } from "../../constants/Monster";
import { NPCEntity } from "../../constants/npc/NPC";
import { CardData } from "./Card";

interface MonsterData {
  ref: string;
  data: MonsterEntity;
}

interface NPCData {
  ref: string;
  data: NPCEntity;
}

export const monsterDataConverter = (monsterData: MonsterData): CardData => {
  const referenceId = monsterData.ref.value.id;

  const tags = [monsterData.data.powerLevel];
  monsterData.data.tags.forEach((tag) => tags.push(tag));

  return {
    name: monsterData.data.name,
    summary: monsterData.data.motivation,
    tags: tags,
    previewS3Key: monsterData.data.previewS3Key,
    fileS3Key: monsterData.data.fileS3Key,
    referenceId: referenceId,
  };
};

export const NPCDataConverter = (npcData: NPCData): CardData => {
  const referenceId = npcData.ref.value.id;

  const tags = [npcData.data.template, npcData.data.archetype];

  return {
    name: npcData.data.name,
    summary: npcData.data.ideal,
    tags: tags,
    previewS3Key: npcData.data.previewS3Key,
    fileS3Key: npcData.data.fileS3Key,
    referenceId: referenceId,
  };
};
